import { KSpan, KTitleSpan, KTooltip } from "kahuna-base-react-components"
//@ts-ignore
import ArrowUpIcon from "../../../../assets/analytics_icons/arrow-up-green.svg"
//@ts-ignore
import ArrowDownIcon from "../../../../assets/analytics_icons/arrow-down-red.svg"

const Card = ({
  title,
  value,
  icon,
  tooltipContent,
  percentChange,
  disabled
}: {
  title: string
  value: string
  icon: string
  tooltipContent?: string
  percentChange?: number
  disabled?: boolean
}) => {
  return (
    <div className="w-full">
      <KTooltip
        width="240px"
        content={tooltipContent ? <KSpan text={tooltipContent} fontSize={12} lineHeight="14px" color="#111" /> : null}
      >
        <div
          className="w-full h-[120px] p-5 flex flex-row justify-between"
          style={{
            borderRadius: "10px",
            border: "1px solid var(--stroke-soft-200, #F3F3F3)",
            background: " var(--bg-white-0, #FFF)",
            boxShadow: "0px 2px 4px 0px rgba(27, 28, 29, 0.04)",
            opacity: disabled ? 0.55 : 1,
            filter: disabled ? "grayscale(1)" : "none",
            pointerEvents: disabled ? "none" : "auto"
          }}
        >
          <div className="flex flex-col justify-between">
            <KTitleSpan text={title} fontSize={16} lineHeight="20px" color="#737373" />
            <div className="flex flex-row items-end gap-1">
              <KSpan text={value} fontSize={24} lineHeight="28px" color="#111" fontWeight={600} />

              {!!percentChange && (
                <div className="flex flex-row items-center gap-1 pb-[3px]">
                  <img src={percentChange > 0 ? ArrowUpIcon : ArrowDownIcon} alt="change-icon" height={16} width={16} />
                  <KSpan
                    text={`${percentChange.toFixed(1)}%`}
                    color={percentChange > 0 ? "#318D18" : "#D02E20"}
                    fontSize={13}
                    lineHeight="16px"
                    fontWeight={500}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="flex flex-row justify-end items-start">
            <div className="flex items-center justify-center w-10 h-10 rounded-[12px] bg-[#F3F3F3]">
              <img
                src={icon}
                style={{
                  width: 20,
                  height: 20,
                  minWidth: 20,
                  maxWidth: 20
                }}
                alt="card-icon"
              />
            </div>
          </div>
        </div>
      </KTooltip>
    </div>
  )
}

export default Card
